import "./HeaderArticle.css";
import Title from "../../common/Title/Title";
import SEO from "../../common/SEO/SEO";
import HighlightText from "../../texts/HighlightText/HighlightText";
import ReadMoreSection from "../../common/ReadMoreSection/ReadMoreSection";
import TableOfContent from "../TableOfContent/TableOfContent";

export default function HeaderArticle({ title, titleLineHeight, titleWidth, description, url, image, imageHeader, tableOfContents, readMore }) {

  return (
    <>
        <SEO title={title} description={description} url={url} image={image} />
        <div className="blurry-image-container" style={{ height: "500px" }}>
            <img
                src={imageHeader}
                alt="Job Header"
                className="blurry-image-header"
            />
            <div className="blurry-image-overlay" />
        </div>
        <div className="header-container">
            <div className="header-content-article">
                <div className="header-article">
                    <div style={{ display: "flex", width: "100%", flexDirection: "column", alignItems: "flex-start", gap: "50px" }}>
                      <div style={{textAlign: "left", width: titleWidth}}>
                        <Title text={title} lineHeight={titleLineHeight} size="2.5rem" color="var(--color-blue)" level="h1"/>
                      </div>
                        <div style={{ textAlign: "left", marginLeft: "50px" }}>
                            <HighlightText text={description} size="1rem" alignItems="flex-start" />
                        </div>
                    </div>
                    <TableOfContent tableOfContents={tableOfContents} />
                </div>
            </div>
            <aside className="read-more-section">
                <ReadMoreSection items={readMore} />
            </aside>
        </div>
    </>
  );
}
